import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendarAddFlip = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m19.762 9.8-.392-2.544c-.163-1.062-1.04-1.843-2.07-1.843H7.18c-1.292 0-2.277 1.206-2.072 2.537l1.565 10.176c.163 1.062 1.041 1.843 2.071 1.843h1.511"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.163 5.413H6.625c-1.03 0-1.907.78-2.07 1.843L2.988 17.43c-.204 1.331.78 2.538 2.072 2.538h3.264"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.844 7.17c.19.23.316.195.566.195.652 0 1.18-.918 1.18-2.05s-.528-2.048-1.18-2.048c-.347 0-.551.04-.767.456M14.753 7.17c.19.23.316.195.566.195.652 0 1.18-.918 1.18-2.05s-.528-2.048-1.18-2.048c-.348 0-.551.04-.767.456M14.513 16.08h3.815m-1.907 1.908v-3.815"
    />
    <circle
      cx={16.384}
      cy={16.08}
      r={4.654}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendarAddFlip);
export default ForwardRef;
